<tc-master-operator-simulate-form
  *ngIf="connectSettings"
  [connectSettings]="connectSettings"
></tc-master-operator-simulate-form>
